import NeighborhoodPageContent from "../NeighborhoodPageContent";

export default function BailenMiraflores() {
  return <NeighborhoodPageContent slug="bailen-miraflores" />;
}